export default function useFooterMenu() {
  const { aposte, comunidade, regras } = useFooterLinks();
  const contactUrl = localeLink('/contact');

  return { aposte, comunidade, regras, contactUrl };
}
